import { render, staticRenderFns } from "./Permissao.vue?vue&type=template&id=aee00780&scoped=true"
import script from "./Permissao.vue?vue&type=script&lang=js"
export * from "./Permissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee00780",
  null
  
)

export default component.exports